import React from 'react'

import { LntButton, LntDivider, LntForm, LntFormItem, LntModal, LntModalFooter, LntSelect } from '@app/components/base'

import { FILTERS_PLACEHOLDERS } from '@app/constants/filters'
import { BUTTON_TYPE, SIZE } from '@app/constants'
import { LOCATION_KEY, MONITORINGS_TYPES_KEY } from '@app/constants/queryKeys'

import { getClusterGroups } from '@app/api/routes/locationClusterGroups'
import { getStores } from '@app/api/routes/locationStores'
import { getClusters } from '@app/api/routes/locationСlusters'
import { getTypes } from '@app/api/routes/monitorings'
import { getSalesOrganization } from '@app/api/routes/locationSalesOrganization'

import { getFilterFromEntities } from '@app/utils/entitiesAdapters'

import styles from './styles.module.scss'

import type { LntSelectProps } from '@app/components/base/Select/types'
import type { CopyQuotaData } from '@app/api/routes/quotaReports/types'
import type { CopyQuotaModalProps } from './types'

const commonSelectProps: LntSelectProps = {
  showArrow: true,
  mode: 'multiple',
  size: SIZE.middle
}

export const CopyQuotaModal: React.FC<CopyQuotaModalProps> = props => {
  const { onCreateQuota, ...restProps } = props

  const handleSubmit = (data: CopyQuotaData): void => onCreateQuota?.(data)

  return (
    <LntModal
      { ...restProps }
      title='Копировать квоты'
      footer={ null }
      width={ 444 }
    >
      <LntForm
        onSubmit={ handleSubmit }
        layout='vertical'
      >
        <LntFormItem
          name='monitoringTypeIds'
          label='Выберите тип мониторинга'
          defaultValue={ [] }
          validationOptions={ { rules: { required: 'Выберите хотя бы один тип' } } }
          className={ styles.copyQuotaModalFormItem }
        >
          <LntSelect
            { ...commonSelectProps }
            placeholder={ `${FILTERS_PLACEHOLDERS.monitoringsTypeFilter} *` }
            querySelect={ {
              queryKey: [MONITORINGS_TYPES_KEY.typesItems],
              queryFn: getTypes,
              select: getFilterFromEntities
            } }
          />
        </LntFormItem>

        <LntDivider />

        <LntFormItem
          name='clustersGroupIds'
          label='Выберите область применения'
          defaultValue={ [] }
          className={ styles.copyQuotaModalFormItem }
        >
          <LntSelect
            { ...commonSelectProps }
            placeholder={ FILTERS_PLACEHOLDERS.storesFilter }
            querySelect={ {
              queryKey: [LOCATION_KEY.locationStoresItems],
              queryFn: getStores,
              select: getFilterFromEntities
            } }
          />
        </LntFormItem>

        <LntFormItem
          name='clusterIds'
          defaultValue={ [] }
          className={ styles.copyQuotaModalFormItem }
        >
          <LntSelect
            { ...commonSelectProps }
            placeholder={ FILTERS_PLACEHOLDERS.clustersFilter }
            querySelect={ {
              queryKey: [LOCATION_KEY.locationClustersItems],
              queryFn: getClusters,
              select: getFilterFromEntities
            } }
          />
        </LntFormItem>

        <LntFormItem
          name='storeIds'
          defaultValue={ [] }
          className={ styles.copyQuotaModalFormItem }
        >
          <LntSelect
            { ...commonSelectProps }
            placeholder={ FILTERS_PLACEHOLDERS.clusterGroupsFilter }
            querySelect={ {
              queryKey: [LOCATION_KEY.locationClusterGroupsItems],
              queryFn: getClusterGroups,
              select: getFilterFromEntities
            } }
          />
        </LntFormItem>

        <LntFormItem
          name='salesOrganizationIds'
          defaultValue={ [] }
          className={ styles.copyQuotaModalFormItem }
        >
          <LntSelect
            { ...commonSelectProps }
            placeholder={ FILTERS_PLACEHOLDERS.salesOrganizationFilter }
            querySelect={ {
              queryKey: [LOCATION_KEY.locationSalesOrganizationsItems],
              queryFn: getSalesOrganization,
              select: getFilterFromEntities
            } }
          />
        </LntFormItem>

        <LntModalFooter>
          <LntButton
            htmlType='submit'
            type={ BUTTON_TYPE.primary }
            size={ SIZE.middle }
          >
            Копировать
          </LntButton>
        </LntModalFooter>
      </LntForm>
    </LntModal>
  )
}
